export default "__VITE_ASSET__TpvLxf0I__"